// Hostnames where Microsoft SSO is enabled
export const MICROSOFT_SSO_ALLOWED_HOSTNAMES = [
  "compassus.circadia.link",
  "localhost",
] as const;

export type MicrosoftSSOAllowedHostname =
  (typeof MICROSOFT_SSO_ALLOWED_HOSTNAMES)[number];

export const isMicrosoftSSOEnabled = (): boolean =>
  MICROSOFT_SSO_ALLOWED_HOSTNAMES.includes(
    window.location.hostname as MicrosoftSSOAllowedHostname
  );

/**
 * Check if the current user logged in via Microsoft SSO.
 * This is stored in localStorage to survive page refreshes.
 */
export const isMicrosoftSSOUser = (): boolean =>
  localStorage.getItem("microsoftSso") === "true";

/**
 * Check if user should be treated as a home_health_external user.
 * This is true if they either:
 * 1. Belong to the "home_health_external" Cognito group, OR
 * 2. Logged in via Microsoft SSO (workaround until Cognito group assignment is fixed)
 */
export const isHomeHealthExternalUser = (
  userGroups?: string[] | null
): boolean => {
  const hasGroup = userGroups?.includes("home_health_external") ?? false;
  const isMicrosoftSSO = isMicrosoftSSOUser();
  return hasGroup || isMicrosoftSSO;
};
